module.exports = __webpack_public_path__ + "static/img/intro-0.bfc7d15e.png";